/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import apiService from './index'

export const updateProfile = async (data: any, userId: string) => {
  return await apiService.patch(`${process.env.REACT_APP_BACKEND_URL_V3}/user/profile/${userId}`, data)
}

export const updateProfileImage = async (userId: string, data: any) => {
  return await apiService.patch(`${process.env.REACT_APP_BACKEND_URL}/user/image/${userId}`, data)
}

export const userPreviousImageBase64 = async (data: any) => {
  return await apiService.post(`${process.env.REACT_APP_BACKEND_URL_V3}/user/process/imageuri`, data)
}

export const requestEmailChange = async (data: { newEmail: string; password: string }) => {
  return await apiService.post(`${process.env.REACT_APP_BACKEND_URL_V3}/user/email/request`, data)
}

export const verifyEmailChange = async (token: string) => {
  return await apiService.post(`${process.env.REACT_APP_BACKEND_URL_V3}/user/email/verify?token=${token}`)
}
